module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-04-07-847_com.pinkcoffee.sexbattle.ab521f0b.jpg";